import {CSSProperties} from 'react'
import {useTheme} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {StyledInfoBanner} from './style'

export const InfoBanner = ({
    title,
    subtitle,
    maxWidth
}: {
    title: string
    subtitle?: string
    maxWidth?: CSSProperties['maxWidth']
}) => {
    const {palette} = useTheme()

    return (
        <StyledInfoBanner style={{maxWidth}}>
            <AlertCircleIcon size={15} color={palette.primary['600']} />
            <Flexbox direction="column" gap={0.5}>
                <Text weight="500" size="textSm" palette="primary" shade="900">
                    {title}
                </Text>
                {subtitle && (
                    <Text size="textSm" palette="primary" shade="700">
                        {subtitle}
                    </Text>
                )}
            </Flexbox>
        </StyledInfoBanner>
    )
}
